import { InfoCircleFilled } from '@creditornot/cb-icons';
import { colors, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import { Typography } from 'common/typography';

export type DisclaimerProps = {
  text: string;
};

const StyledRoot = styled.div`
  display: flex;
  align-items: baseline;
  color: ${cbSemanticCssVars.textSecondary};
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt72 })};
  padding-block-start: 8px;
  gap: 8px;
`;

const StyledIcon = styled(InfoCircleFilled).attrs({ width: '12px' })`
  flex-shrink: 0;
`;

export const HelperText = ({ text }: DisclaimerProps) => (
  <StyledRoot>
    <StyledIcon />
    <Typography.Body3>{text}</Typography.Body3>
  </StyledRoot>
);
